<template>
  <v-card
    color="blue-grey darken-1"
    dark
    :loading="loading"
    height="100%"
  >
    <template v-slot:progress>
      <v-progress-linear
        absolute
        color="green lighten-3"
        height="4"
        indeterminate
      ></v-progress-linear>
    </template>
    <v-img
      height="200"
      src="https://waste-destination-images.s3.amazonaws.com/ubtane_plane_background_2.jpg"
    >
      <template v-if="list">
      
      <v-row class="" align="start" justify="center">
        <v-col class="text-center pb-1" cols="8" md="6">
          <h3 class="headline green--text ligten-1" v-if="!editName">{{ list ? list.get("name") : 'Title' }}
          <v-icon small v-if="!editName && listOwner" @click="handleEditName" class="ml-1 mb-1">edit</v-icon>
          </h3>
          <h3 class="headline" v-if="editName && listOwner"><v-text-field outlined rounded single-line clearable dense class="" v-model="name" @change="saveList({name:name}); editName=false" @blur="editName=false" autofocus></v-text-field></h3>
        </v-col>
      </v-row>
      <v-row class="" align="start" justify="center">
        <v-col class="text-center pt-0" cols="10" md="6">
          <span class="green--text text--lighten-1" v-if="!editNotes">{{ list ? list.get('notes') : '' }}</span>
          <v-icon small v-if="!editNotes && listOwner" @click="handleEditNotes" class="ml-1 mb-1">edit</v-icon>
          <span class="green--text text--lighten-1" v-if="editNotes && listOwner"><v-textarea outlined rounded single-line clearable dense class="pt-0 mt-0" v-model="notes" @change="saveList({notes:notes}); editNotes=false" @blur="editNotes=false" autofocus></v-textarea></span>
        </v-col>
      </v-row>
      <v-row class="" align="start" justify="center">
        <v-col class="text-center pt-0" cols="8">
          <span class="green--text text--lighten-1">Created by: {{list && list.get('createdBy') ? list.get('createdBy').get('name') : ''}}</span>
        </v-col>
      </v-row>
      </template>
    </v-img>
    <v-row class="ml-4 mr-4 mt-4">
      <places-search v-if="listOwner"/>
    </v-row>      
    <places-list :list="list ? list.get('places') : []"/>
    <v-col cols="12">
      <v-row align="end" justify="end">
      <v-divider class="mt-4"></v-divider>
        <v-card-actions>
        
        <div id="googleAttributes"></div>
      </v-card-actions>
    </v-row>
    </v-col>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
import { mapActions } from "vuex";
import PlacesList from "@/components/PlacesList.vue"
import PlacesSearch from "@/components/PlacesSearch.vue"

export default {
  props: ['objectId'],
  data() {
    return {
      editName: false,
      editNotes: false,
      notes: '',
      name: '',
    };
  },
  components: {
    'places-list': PlacesList,
    'places-search': PlacesSearch,
  },
  methods: {
    ...mapActions(['getList', 'saveList']),
    handleEditName() {
      if (this.listOwner) {
        this.editName = true; 
        this.name = this.list ? this.list.get('name') : ''
      }
    },
    handleEditNotes() {
      if (this.listOwner) {
        this.editNotes= true; 
        this.notes = this.list ? this.list.get('notes') : ''
      }
    }
  },
  computed: {
    ...mapState(['list', 'loading', 'user']),
    listOwner() {
      var x = this.list ? this.list.get('createdBy') : null;
      if (this.user && x && x.id === this.user.id) return true
      return false
    },
  },
  mounted () {
    this.getList(this.objectId)
  },
  watch: {
  },
};
</script>
